export function normalizeRegionCode(value: unknown): string {
  return typeof value === 'string' ? value.trim().toLowerCase() : ''
}

/** Fallback when the shell has not wired Postmate `regionCode` yet (spm-ts #13565). */
export function regionFromJwt(token: unknown): string {
  if (typeof token !== 'string') {
    return ''
  }
  const parts = token.split('.')
  if (parts.length < 2) {
    return ''
  }
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const payload = JSON.parse(atob(base64)) as { region?: unknown }
    return normalizeRegionCode(payload.region)
  } catch {
    return ''
  }
}

export function resolveRegionCode(regionCode: unknown, token: unknown): string {
  return normalizeRegionCode(regionCode) || regionFromJwt(token)
}
